/*
 * Implements functionality which allows highlighting words in text
 * depending on container over textarea
 */
import { exists } from '@engine/lib/utility/exists';

function createLayer(selector) {
  var $backdrop = $(selector + ' .backdrop');
  var $highlights = $(selector + ' .highlights');
  var $textarea = $(selector + ' .highlight-container textarea');

  function applyHighlights(text) {
    var highlighted_text = text.replace(/\n$/g, '\n\n').replace('%{privacy_policy}', '<mark>$&</mark>').replace('%{terms_and_conditions}', '<mark>$&</mark>');
    return highlighted_text;
  }

  function handleInput() {
    var text = $textarea.val();
    var highlightedText = applyHighlights(text);
    $highlights.html(highlightedText);
  }

  function handleScroll() {
    var scrollTop = $textarea.scrollTop();
    $backdrop.scrollTop(scrollTop);
    var scrollLeft = $textarea.scrollLeft();
    $backdrop.scrollLeft(scrollLeft);
  }

  function bindEvents() {
    $textarea.on({
      input: handleInput,
      focus: handleInput,
      scroll: handleScroll
    });
  }

  bindEvents();

  if ($(selector).is(':visible')) {
    handleInput();
  }
}

function init() {
  var highlightSelectors = ['#tac-and-policy-form'];
  highlightSelectors.forEach(function (selector) {
    if (exists(selector)) {
      createLayer(selector);
    }
  });
}

var HighlightText = {
  init: init
};
export default HighlightText;